import React from 'react';

function Check(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.8636 17.9999C9.5876 17.9999 9.32361 17.8859 9.13461 17.6849L4.27171 12.506C3.89272 12.104 3.91372 11.471 4.31571 11.093C4.7187 10.71501 5.35169 10.73501 5.72868 11.137L9.8536 15.5279L18.2614 6.32611C18.6354 5.91711 19.2674 5.89012 19.6754 6.26211C20.0824 6.6341 20.1104 7.26709 19.7384 7.67408L10.6016 17.6739C10.4146 17.8799 10.1486 17.9979 9.8706 17.9999H9.8636Z"
      />
    </svg>
  );
}

Check.displayName = 'Check';

export default Check;
